import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { WMAIApiService, EsperienzeListConfig, Experience } from '../../core';
import { TranslateService } from '@ngx-translate/core';
import { WgisService } from '../../wgis/wgis.service';
import { WGisDisplayMode } from '../../wgis/wgis.utils';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-esperienza-list',
  templateUrl: './esperienza-list.component.html'
})
export class EsperienzaListComponent implements OnInit, OnDestroy {

  panelOpen: boolean = false;
  isMapVisible: boolean = false;
  isSmallScreen: boolean = false;

  
  languageSubscription: Subscription;

  constructor(
    private wmaiservice: WMAIApiService,
    private translateService: TranslateService,
    private wgisservice: WgisService,
    private breakpointObserver: BreakpointObserver,
  ) {
    this.wgisservice.wgisVisible.subscribe((mode: WGisDisplayMode) => {
      this.isMapVisible = (mode !== WGisDisplayMode.Invisible);
    });
    this.subscribeLanguage();
   }

  @Input() limit: number;
  @Input() 
  set config(config: EsperienzeListConfig) {
    if (config) {
      this.query = config;
      this.currentPage = 1;
      this.getListaEsperienze()
    }
  }

  query: EsperienzeListConfig;
  results: Experience[] = [];
  resultsCount: number = 0;
  loading = true;
  pageSize = 6;
  maxSize = 5;
  ellipses = true;
  currentPage = 1;
  totalPages: Array<number> = [];

  selectedPage: number;

  setPageTo(pagenumber) {
    this.currentPage = pagenumber;
    this.results = [];
    this.getListaEsperienze();
  }

  ngOnInit() {
    this.isSmallScreen = this.breakpointObserver.isMatched('(max-width: 768px)');
  }

  ngOnDestroy(){
    this.languageSubscription.unsubscribe();
  }

  subscribeLanguage(){
    this.languageSubscription = this.translateService.onLangChange.subscribe(() => {
      this.results = [];
      this.currentPage = 1;
      this.getListaEsperienze();
    })
  }

  getListaEsperienze() {
    if (this.limit) {
      this.query.type = "latest";
      this.query.filters.limit = this.limit;
      this.query.filters.pageNumber =  this.currentPage;
      this.query.filters.pageSize = this.pageSize;
      this.query.filters.locale = this.translateService.getDefaultLang();
    }

    this.wmaiservice.queryLatestEsperienze(this.query).subscribe(
      data =>  {
        if (data != null) {
            this.results = data['data'];
            this.loading = false;
            if (this.results != null) {
              this.resultsCount = data['metadata']['rowCount'];
              let tmp = Math.ceil(this.resultsCount / this.limit) + 1;
              this.totalPages =  this.resultsCount <= 6 ? this.totalPages : Array.from(new Array<number>(tmp).keys()).map(x => ++x);
          }
        }
    });
  }

  displaymap() {
    this.wgisservice.cmdToggleMap();
    this.isMapVisible = this.wgisservice.getMapVisible();
  }

}
